<template>
  <div class="hall bid-open-hall" :class="{ 'hall-light': theme === 'light' }">
    <div class="hall-head">
      <div class="hall-head--back" @click="back">返回</div>
      <div v-if="isShowKpbBiddersOnlineNum" class="hall-head--supplier-num">
        在线供应商数：{{ KpbBiddersOnlineInfo.onlineCnt }}
      </div>
      <div class="hall-head--title">{{ hallTitle }}</div>
      <div class="hall-head--tool flex">
        <div v-if="showTitleTime" class="tool-time">
          国家授时中心标准时间 {{ systemTime }}
        </div>
        <el-radio-group v-model="theme" class="theme-select" size="small">
          <el-radio-button label="dark">深色</el-radio-button>
          <el-radio-button label="light">浅色</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="hall-body">
      <router-view :theme="theme" />
      <slot></slot>
    </div>

    <!--<div v-if="decryptSpinning" class="spin-wrap">-->
    <!--  <a-spin tip="正在努力排队解密中，请稍后……" size="large" />-->
    <!--</div>-->
  </div>
</template>

<script>
import DateUtils from '@/utils/date'
import { getSystemTimeApi } from '@/api/hall/bid-open-hall'
import { mapState } from 'vuex'

export default {
  name: 'BidOpenHallLayout',

  data() {
    return {
      hallTitle: '精彩纵横开标大厅',
      showTitleTime: true,
      decryptSpinning: false,

      // 颜色主题
      theme: 'dark'
    }
  },

  computed: {
    ...mapState('systemTime', ['systemTime']),
    ...mapState('reviewHall', [
      'KpbBiddersOnlineInfo',
      'isShowKpbBiddersOnlineNum'
    ])
  },

  watch: {
    $route: {
      handler: function(val) {
        if (val.name.includes('Door')) {
          this.showTitleTime = false
        }
      },
      immediate: true,
      deep: true
    },

    theme(val) {
      window.sessionStorage &&
        window.sessionStorage.setItem('bidOpenHallTheme', val)
    }
  },

  created() {
    if (window.sessionStorage) {
      this.theme = window.sessionStorage.getItem('bidOpenHallTheme') || 'dark'
    }
  },

  mounted() {
    // 监听用户离开和回到页面，触发函数，更新数据
    // document.addEventListener('visibilitychange', this.visibilityChange)
    // 监听浏览器窗口的变化
    window.addEventListener('resize', this.keepPageOneScreen)
    // 通过hook监听组件销毁钩子函数
    this.$once('hook:beforeDestroy', () => {
      // document.removeEventListener('visibilitychange', this.visibilityChange)
      window.removeEventListener('resize', this.keepPageOneScreen)
      this.$store.dispatch('systemTime/cleanSystemTimeInterval')
    })
    this.keepPageOneScreen()
    this.$store.dispatch('systemTime/getSystemTime', true)
  },

  methods: {
    /**
     * 保持大厅一屏，计算当前屏幕的高度与1080p进行等比缩放
     */
    keepPageOneScreen() {
      const screenHeight = document.querySelector('html').clientHeight
      this.ratio = screenHeight / 1055
      document.querySelector(
        '.hall'
      ).style.cssText = `transform-origin:0 0; width: ${(1 / this.ratio) *
        100}vw; transform: scale(${this.ratio})`
    },

    back() {
      this.$router.back()
    },

    /**
     * 获取服务器时间
     */
    getSystemTime() {
      return new Promise((resolve, reject) => {
        getSystemTimeApi()
          .then(res => {
            this.countryTimeMillisecond = res.data
            this.startCountryTimeCountDown()
            resolve(res)
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
            reject(err)
          })
      })
    },

    /**
     * 国家授时中心
     */
    startCountryTimeCountDown() {
      this.countryTimeInterval = setInterval(() => {
        if (this.countryTimeCount === 60) {
          this.getSystemTime()
          this.countryTimeCount = 0
        }

        const tempDate = new Date((this.countryTimeMillisecond += 1000))
        this.countryTimeCount++
        this.countryTime = DateUtils.format(tempDate, 'yyyy.MM.dd hh:mm:ss')
        this.time = DateUtils.format(tempDate, 'hh:mm:ss')
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
$background-color: #000e23;

.hall {
  position: absolute;
  top: 0;
  left: 0;
  height: 1054px;
  box-sizing: border-box;
  background-color: $background-color;
  display: flex;
  flex-direction: column;

  &.hall-light {
    background-color: $white-color;

    .hall-head {
      background-image: url('~@/assets/images/hall/bid-open-hall-head-light.png');
      background-color: $primary-color;

      .hall-head--title {
        color: $white-color;
      }
    }
  }

  .hall-head {
    width: 100%;
    height: 77px;
    background: url('~@/assets/images/hall/bid-open-hall-head.png') no-repeat;
    background-size: 100% 56px;
    background-position: 0px 21px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 21px;
    padding-bottom: 13px;
    position: relative;

    .hall-head--back {
      width: 64px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #ffffff;
      border-radius: 4px;
      color: #feffff;
      position: absolute;
      bottom: 6px;
      left: 32px;
      z-index: 10;
      cursor: pointer;
    }

    .hall-head--title {
      font-size: 40px;
      font-weight: 400;
      line-height: 1;
      color: #27d8fe;
      // 下面的样式ie不支持
      //background: linear-gradient(to bottom, #80f2ff, #5197ff);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
      letter-spacing: 0.2em;
    }

    .hall-head--tool {
      position: absolute;
      bottom: 8px;
      right: 32px;
      outline: none;

      .tool-time {
        color: $white-color;
      }

      .theme-select {
        margin-left: 33px;

        ::v-deep {
          .el-radio-button__inner {
            background-color: transparent;
            color: $white-color;
            border-color: $white-color;
          }
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background-color: $white-color;
            color: $background-color;
          }
        }
      }
    }

    .hall-head--supplier-num {
      font-size: 16px;
      color: #fff;
      position: absolute;
      left: 151px;
      bottom: 12px;
      z-index: 10;
    }
  }

  .hall-body {
    width: 100%;
    flex: 1;
    overflow: hidden;
  }
}

.spin-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
}
</style>
